<template>
  <div class="header_box">
    <div>
      <i class="iconfont">&#xe640; 您好，{{this.$store.state.principal}}先生/女士</i>
      <!-- <i class="iconfont">&#xe62a; 切換帳號</i> -->
      <!-- <i>登出</i> -->
      <i class="iconfont" @click="loginOut()">&#xe715; 登出</i>
      <i class="iconfont">&#xe61e; 消息中心({{newsNumber}})</i>
      <i class="iconfont" @click="goHelpCore()">&#xe600; 幫助中心</i>
      <i class="iconfont">&#xe70f; 開發文檔 <span>&#xe7a4;</span></i>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Header',
  props: {
  },
  data() {
    return {
      newsNumber: 0,
      routeUrl:'',
    }
  },
  computed: {
    principal(){
      return this.$store.state.principal;
    }
  },
  methods:{
    loginOut(){
      // console.log(this.$route.path);
      this.routeUrl = this.$route.path;
      axios.get(this.$store.state.axiosLoginOutUrl, {
        params: {
            uid: this.$store.state.uid,
            url: this.routeUrl,
            aution: 1,
        }
      }).then((res) => {
        // console.log(res.data);
      })
      localStorage.clear();
      this.$router.push("/");
      // this.$store.commit('changeQuit', '0');
    },
		goHelpCore(){
      
      this.$router.push("/login/help");
		  // window.location.href = this.$store.state.axiosHelpUrl;
		}
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header_box {
    font-size: 11px;
    height: 46px;
    background: black;
    color: #ffffff;
    min-width: 650px;
  }
   .header_box div {
     float: right;
     margin-right: 16px;
   }
  .header_box div .iconfont {
    font-size: 11px;
    margin: 0 12px;
    line-height: 46px;
		cursor: pointer;
  }
  .header_box div .iconfont span {
    color: #e73262;
  }
	.header_box i:hover  {
	  padding-bottom: 2px;
	  border-bottom: #e73262 2px solid;
	}
	.header_box i:first-child {
	  border-left: 0;
	}
</style>
